module.exports = __webpack_public_path__ + "img/hw.76251292.png";